import * as React from 'react';
import { TApiChemicalProductVendor } from '../../../types/Chemical';
import { ChangeEvent } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Grid } from '@mui/material';
import { useChemicalProductStyles } from '../ChemicalProduct.styles';
import Button from '@mui/material/Button';

interface IEmergency {
  emergencyInformation?: string;
  emergencyPhone?: string;
  vendor?: TApiChemicalProductVendor;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
    supplierButton: {
      borderRadius: '15px',
      backgroundColor: '#7bcb00',
      '&:hover': {
        backgroundColor: '#639714',
      },
    },
    emergencyPhoneHeader: {
      margin: '0',
    }
  })
);

const Emergency: React.FC<IEmergency> = ({
  emergencyInformation,
  emergencyPhone,
  vendor,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});
  const classesVendor = useChemicalProductStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel10`)}
      key={'panel10'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel10bh-content`}
        id={`panel10bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.emergency')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
          {emergencyPhone && (
            <div className={classesVendor.companyDetails}>
              <h3 className={classes.emergencyPhoneHeader}>{t('chemicals.emergency_phone')}</h3>
              <p>
                <Grid container justifyContent='space-around'>
                  <Grid item xs={12}>
                    <Button
                      type='button'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.supplierButton}
                      href={`tel:${emergencyPhone}`}
                    >
                      {emergencyPhone}
                    </Button>
                  </Grid>
                </Grid>
              </p>
            </div>
          )}
        {emergencyInformation && (
              <Typography
                dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.emergency_information')}</b> ${emergencyInformation}` }}
              />
            )}
            {vendor && (
              <div className={classesVendor.companyDetails}>
                <h3 className={classes.emergencyPhoneHeader}>{t('chemicals.supplier')}</h3>
                <p>
                  {vendor.name}
                  <br />
                  {vendor.streetAddress}
                  <br />
                  {vendor.postalCode}{' '}{vendor.city},
                  <br />
                  {vendor.country}
                  <br />
                  {t('auth.email.label')}: <u><a href={`mailto:${vendor.email}`}>{vendor.email}</a></u>
                  <br />
                  {t('chemicals.phone')}: {' '}{vendor.phone}
                  <br />
                </p>
              </div>
            )}

          </AccordionDetails>
          </Accordion>
          );
        };

export default Emergency;